import React from "react";
import ModalLauncher from "../containers/ModalLauncher";

export default function launchModal(modal, Launcher = ModalLauncher) {
  return props => <Launcher {...props} modal={modal} />;
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/launchModal.jsx